import * as React from "react"

import { SidebarItem } from "../types"

import Link from "./Link"
import { Bar } from "./Styles"

interface SidebarProps {
  items: Array<SidebarItem>
}

const Sidebar = ({ items }: SidebarProps): JSX.Element => {
  return (
    <Bar>
      {items.map((item, index) => (
        <Link key={index} {...item} />
      ))}
    </Bar>
  )
}

export default Sidebar
